import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header/index";
import Footer from "./components/Footer/index";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
const About = lazy(() => import("./pages/About"));
const Projects = lazy(() => import("./pages/Projects"));
const ProjectDetail = lazy(() => import("./pages/ProjectDetail"));
const Contact = lazy(() => import("./pages/Contact"));
const Clients = lazy(() => import("./pages/Clients"));
const Company = lazy(() => import("./pages/Company"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogDetail = lazy(() => import("./pages/BlogDetail"));
const News = lazy(() => import("./pages/News"));
const NewsDetail = lazy(() => import("./pages/NewsDetail"));
const DigitalMarketing = lazy(() => import("./pages/DigitalMarketing"));
const WebDesign = lazy(() => import("./pages/WebDesign"));
const Ecommerce = lazy(() => import("./pages/Ecommerce"));
const Maintenance = lazy(() => import("./pages/Maintenance"));
const MobileApp = lazy(() => import("./pages/MobileApp"));
const EnterpriseApp = lazy(() => import("./pages/EnterpriseApp"));
const MediaServices = lazy(() => import("./pages/MediaServices"));
const SearchEngineOptimization = lazy(() => import("./pages/SearchEngineOptimization"));
const SeoServices = lazy(() => import("./pages/SeoServices.jsx"));
const WebDesignServices = lazy(() => import("./pages/WebDesignServices.jsx"));
const WordpressDevelopment = lazy(() => import("./pages/WordpressDevelopment.jsx"));
const ReactDevelopment = lazy(() => import("./pages/ReactDevelopment.jsx"));
const SocialMediaManagement = lazy(() => import("./pages/SocialMediaManagement"));
const SearchEngineMarketing = lazy(() => import("./pages/SearchEngineMarketing"));
const InteractiveMedia = lazy(() => import("./pages/InteractiveMedia"));
const VideoServices = lazy(() => import("./pages/VideoServices"));
const BrandingServices = lazy(() => import("./pages/BrandingServices"));
const CustomWebApplications = lazy(() => import("./pages/CustomWebApplications"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const Sitemap = lazy(() => import("./pages/Sitemap"));
const Cookies = lazy(() => import("./pages/Cookies"));
const DigitalMarketingNoida = lazy(() => import("./pages/DigitalMarketingNoida"));
const SEOCompanyDelhi = lazy(() => import("./pages/SEOCompanyDelhi"));
const SEOCompanyNoida = lazy(() => import("./pages/SEOCompanyNoida"));
const SocialMediaCompanyDelhi = lazy(() => import("./pages/SocialMediaCompanyDelhi"));
const WebDesignCompanyDelhi = lazy(() => import("./pages/WebDesignCompanyDelhi"));
const WebDesignCompanyNoida = lazy(() => import("./pages/WebDesignCompanyNoida"));
const WebDevelopmentCompanyDelhi = lazy(() => import("./pages/WebDevelopmentCompanyDelhi"));
const WebDevelopmentCompanyNoida = lazy(() => import("./pages/WebDevelopmentCompanyNoida"));
const WebDevelopmentServices = lazy(() => import("./pages/WebDevelopmentServices.jsx"));
const WebDeveloperGhaziabad = lazy(() => import("./pages/WebDeveloperGhaziabad"));
const WebDeveloperDelhi = lazy(() => import("./pages/WebDeveloperDelhi"));
const WebDevelopmentCompanyMumbai = lazy(() => import("./pages/WebDevelopmentCompanyMumbai"));
const WebDevelopmentCompanyBengaluru = lazy(() => import("./pages/WebDevelopmentCompanyBengaluru"));
const WebDevelopmentCompanyHyderabad = lazy(() => import("./pages/WebDevelopmentCompanyHyderabad"));
const WebDevelopmentCompanyChennai = lazy(() => import("./pages/WebDevelopmentCompanyChennai"));
const WebDevelopmentCompanyKolkata = lazy(() => import("./pages/WebDevelopmentCompanyKolkata"));
const WebDevelopmentCompanyPune = lazy(() => import("./pages/WebDevelopmentCompanyPune"));
const WebDevelopmentCompanyAhmedabad = lazy(() => import("./pages/WebDevelopmentCompanyAhmedabad"));
const WebDevelopmentCompanySurat = lazy(() => import("./pages/WebDevelopmentCompanySurat"));
const WebDevelopmentCompanyJaipur = lazy(() => import("./pages/WebDevelopmentCompanyJaipur"));
const WebDevelopmentCompanyLucknow = lazy(() => import("./pages/WebDevelopmentCompanyLucknow"));
const WebDevelopmentCompanyKanpur = lazy(() => import("./pages/WebDevelopmentCompanyKanpur"));
const WebDevelopmentCompanyNagpur = lazy(() => import("./pages/WebDevelopmentCompanyNagpur"));
const WebDevelopmentCompanyIndore = lazy(() => import("./pages/WebDevelopmentCompanyIndore"));
const WebDevelopmentCompanyBhopal = lazy(() => import("./pages/WebDevelopmentCompanyBhopal"));
const WebDevelopmentCompanyChandigarh = lazy(() => import("./pages/WebDevelopmentCompanyChandigarh"));
const WebDevelopmentCompanyGurgaon = lazy(() => import("./pages/WebDevelopmentCompanyGurgaon"));
const WebDevelopmentCompanyKochi = lazy(() => import("./pages/WebDevelopmentCompanyKochi"));
const WebDevelopmentCompanyVisakhapatnam = lazy(() => import("./pages/WebDevelopmentCompanyVisakhapatnam"));
const WebDevelopmentCompanyGhaziabad = lazy(() => import("./pages/WebDevelopmentCompanyGhaziabad"));
const FreelanceAIDeveloperNoida = lazy(() => import("./pages/FreelanceAIDeveloperNoida"));

function App() {
  return (
    <div className="flex flex-col min-h-screen font-sans bg-gray-50 text-gray-900">
      <Header />
      <main className="flex-1">
        <Suspense fallback={<div className="min-h-[40vh]" aria-live="polite" />}>
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/company" element={<Company />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          {/* Services */}
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/web-design" element={<WebDesign />} />
          <Route path="/web-design-development" element={<WebDesign />} />
          <Route path="/web-development" element={<WebDesign />} />
          <Route path="/ecommerce" element={<Ecommerce />} />
          <Route path="/ecommerce-web-development" element={<Ecommerce />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/maintenance-services" element={<Maintenance />} />
          <Route path="/mobile-app-development" element={<MobileApp />} />
          <Route path="/enterprise-app" element={<EnterpriseApp />} />
          <Route path="/enterprise-application" element={<EnterpriseApp />} />
          <Route path="/media-services" element={<MediaServices />} />
          <Route path="/seo" element={<SearchEngineOptimization />} />
          <Route path="/seo-services" element={<SeoServices />} />
          <Route path="/web-design-services" element={<WebDesignServices />} />
          <Route path="/wordpress-development" element={<WordpressDevelopment />} />
          <Route path="/react-development" element={<ReactDevelopment />} />
          <Route path="/smo" element={<SocialMediaManagement />} />
          <Route path="/social-media-management" element={<SocialMediaManagement />} />
          <Route path="/sem" element={<SearchEngineMarketing />} />
          <Route path="/search-engine-marketing" element={<SearchEngineMarketing />} />
          <Route path="/interactive-media" element={<InteractiveMedia />} />
          <Route path="/video-services" element={<VideoServices />} />
          <Route path="/video" element={<VideoServices />} />
          <Route path="/branding" element={<BrandingServices />} />
          <Route path="/branding-services" element={<BrandingServices />} />
          <Route path="/custom-web-app" element={<CustomWebApplications />} />
          <Route path="/custom-web-applications" element={<CustomWebApplications />} />
          {/* Footer Service Pages */}
          <Route path="/digital-marketing-noida" element={<DigitalMarketingNoida />} />
          <Route path="/seo-delhi" element={<SEOCompanyDelhi />} />
          <Route path="/seo-noida" element={<SEOCompanyNoida />} />
          <Route path="/smo-delhi" element={<SocialMediaCompanyDelhi />} />
          <Route path="/website-design-delhi" element={<WebDesignCompanyDelhi />} />
          <Route path="/website-design-noida" element={<WebDesignCompanyNoida />} />
          <Route path="/website-development-delhi" element={<WebDevelopmentCompanyDelhi />} />
          <Route path="/website-development-noida" element={<WebDevelopmentCompanyNoida />} />
          {/* Landing Pages */}
          <Route path="/web-developer-in-ghaziabad" element={<WebDeveloperGhaziabad />} />
          <Route path="/web-developer-in-delhi" element={<WebDeveloperDelhi />} />
          <Route path="/web-development-services" element={<WebDevelopmentServices />} />
          <Route path="/web-development-company-in-mumbai" element={<WebDevelopmentCompanyMumbai />} />
          <Route path="/web-development-company-in-delhi" element={<WebDevelopmentCompanyDelhi />} />
          <Route path="/web-development-company-in-bengaluru" element={<WebDevelopmentCompanyBengaluru />} />
          <Route path="/web-development-company-in-hyderabad" element={<WebDevelopmentCompanyHyderabad />} />
          <Route path="/web-development-company-in-chennai" element={<WebDevelopmentCompanyChennai />} />
          <Route path="/web-development-company-in-kolkata" element={<WebDevelopmentCompanyKolkata />} />
          <Route path="/web-development-company-in-pune" element={<WebDevelopmentCompanyPune />} />
          <Route path="/web-development-company-in-ahmedabad" element={<WebDevelopmentCompanyAhmedabad />} />
          <Route path="/web-development-company-in-surat" element={<WebDevelopmentCompanySurat />} />
          <Route path="/web-development-company-in-jaipur" element={<WebDevelopmentCompanyJaipur />} />
          <Route path="/web-development-company-in-lucknow" element={<WebDevelopmentCompanyLucknow />} />
          <Route path="/web-development-company-in-kanpur" element={<WebDevelopmentCompanyKanpur />} />
          <Route path="/web-development-company-in-nagpur" element={<WebDevelopmentCompanyNagpur />} />
          <Route path="/web-development-company-in-indore" element={<WebDevelopmentCompanyIndore />} />
          <Route path="/web-development-company-in-bhopal" element={<WebDevelopmentCompanyBhopal />} />
          <Route path="/web-development-company-in-chandigarh" element={<WebDevelopmentCompanyChandigarh />} />
          <Route path="/web-development-company-in-noida" element={<WebDevelopmentCompanyNoida />} />
          <Route path="/web-development-company-in-gurgaon" element={<WebDevelopmentCompanyGurgaon />} />
          <Route path="/web-development-company-in-kochi" element={<WebDevelopmentCompanyKochi />} />
          <Route path="/web-development-company-in-visakhapatnam" element={<WebDevelopmentCompanyVisakhapatnam />} />
          <Route path="/web-development-company-in-ghaziabad" element={<WebDevelopmentCompanyGhaziabad />} />
          <Route path="/freelance-ai-developer-noida" element={<FreelanceAIDeveloperNoida />} />
          {/* Legal */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/sitemap" element={<Sitemap />} />
         
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <CookieBanner />
      <ScrollToTop />
    </div>
  );
}

export default App;